var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { colors } from '../../../abstracts/colors';
var typeMap = {
    light: {
        color: colors.black,
        backgroundColor: colors.neutralBrighter
    },
    gray: {
        color: colors.white,
        backgroundColor: colors.neutralDeeper
    },
    dark: {
        color: colors.white,
        backgroundColor: colors.black
    },
    success: {
        color: colors.black,
        backgroundColor: colors.successBright
    },
    warn: {
        color: colors.black,
        backgroundColor: colors.warningBright
    },
    error: {
        color: colors.white,
        backgroundColor: colors.errorDeep
    },
    update: {
        color: colors.black,
        backgroundColor: colors.brandTennis
    },
    attention: {
        color: colors.white,
        backgroundColor: colors.primaryDeep
    },
    disabled: {
        color: colors.neutralBrighter,
        backgroundColor: colors.neutralDeep
    }
};
var regularStyling = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 0.875rem;\n  padding: 3px 4px;\n"], ["\n  font-size: 0.875rem;\n  padding: 3px 4px;\n"])));
var smallStyling = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 0.75rem;\n  padding: 3px 2px 1px 2px;\n"], ["\n  font-size: 0.75rem;\n  padding: 3px 2px 1px 2px;\n"])));
export var StyledTag = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-content: center;\n  justify-content: center;\n  color: ", ";\n  border: 0;\n  border-radius: 2px;\n  background-color: ", ";\n  box-sizing: border-box;\n  width: fit-content;\n\n  ", ";\n"], ["\n  display: flex;\n  align-content: center;\n  justify-content: center;\n  color: ", ";\n  border: 0;\n  border-radius: 2px;\n  background-color: ", ";\n  box-sizing: border-box;\n  width: fit-content;\n\n  ", ";\n"])), function (_a) {
    var type = _a.type;
    return typeMap[type].color;
}, function (_a) {
    var type = _a.type;
    return typeMap[type].backgroundColor;
}, function (_a) {
    var size = _a.size;
    return (size === 'regular' ? regularStyling : smallStyling);
});
var templateObject_1, templateObject_2, templateObject_3;
